module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startedQuiz === false),
      expression: "startedQuiz === false"
    }],
    key: "intro",
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "intro-inner"
  }, [_c('h1', [_vm._v("Measuring Volume Quiz")]), _vm._v(" "), _c('p', [_vm._v("Select the most accurate volume based on the graduated cylinder shown. Then, consider the markings on the cylinder to determine the uncertainty value for the measurement.")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.startedQuiz = true
      }
    }
  }, [_vm._v("Begin Quiz")])])]), _vm._v(" "), _c('quiz', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startedQuiz === true),
      expression: "startedQuiz === true"
    }],
    key: "quizComponent",
    attrs: {
      "questions": _vm.questions
    },
    on: {
      "restartQuiz": function($event) {
        _vm.startedQuiz = false
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11302a2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 13
// module chunks = 1